/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A User
 * @export
 * @interface InternalApiUserBasicDetails
 */
export interface InternalApiUserBasicDetails {
    /**
     * 
     * @type {number}
     * @memberof InternalApiUserBasicDetails
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUserBasicDetails
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiUserBasicDetails
     */
    name: string;
}

/**
 * Check if a given object implements the InternalApiUserBasicDetails interface.
 */
export function instanceOfInternalApiUserBasicDetails(value: object): value is InternalApiUserBasicDetails {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiUserBasicDetailsFromJSON(json: any): InternalApiUserBasicDetails {
    return InternalApiUserBasicDetailsFromJSONTyped(json, false);
}

export function InternalApiUserBasicDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUserBasicDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
    };
}

export function InternalApiUserBasicDetailsToJSON(json: any): InternalApiUserBasicDetails {
    return InternalApiUserBasicDetailsToJSONTyped(json, false);
}

export function InternalApiUserBasicDetailsToJSONTyped(value?: InternalApiUserBasicDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'name': value['name'],
    };
}

